import { combineReducers } from 'redux';
// reducers
import { subscription } from './Subscriptions/SubscriptionsReducers';
import { payments } from './Payments/PaymentReducers';
import { paymentMethods } from './PaymentMethods/PaymentMethodReducers';

// combine
const reducers = combineReducers({
  payments,
  paymentMethods,
  subscription,
});

export default reducers;
